"use strict";
/* eslint-disable */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setActions = exports.updateConfig = exports.config = exports.HttpMethod = void 0;
var HttpMethod;
(function (HttpMethod) {
    HttpMethod["GET"] = "GET";
    HttpMethod["POST"] = "POST";
    HttpMethod["PATCH"] = "PATCH";
    HttpMethod["DELETE"] = "DELETE";
})(HttpMethod = exports.HttpMethod || (exports.HttpMethod = {}));
exports.config = {
    name: 'redux-auth',
    displayName: 'redux auth',
    fetchDelay: 0,
    delayBeforeStart: false,
    delaySuccess: 4000,
    delayWarning: 7000,
    delayError: 10000,
    delayConfirmationEmail: 60000,
    delayChangeEmail: 60000,
    delayNewPassword: 60000,
    delayForgotPassword: 60000,
    delayResendEmail: 60000,
    session: {
        interval: 15 * 1000,
    },
    auth: {
        name: 'auth',
        storageNameForPages: '_auth_pages_',
        storage: {
            name: '_auth_',
        },
    },
    actions: {},
    api: {
        url: 'http://localhost:4000/',
    },
    signIn: {
        // url: 'auth/sign-in', // email and password
        url: {
            baseUrl: 'auth/sign-in',
            byEmail: function () { return 'auth/sign-in'; },
            byUsername: function () { return 'auth/sign-in/username'; },
            byPhone: function () { return 'auth/sign-in/phone'; },
            byService: function (payload) {
                if (payload === null || payload === void 0 ? void 0 : payload.method) {
                    return "auth/sign-in/".concat(payload === null || payload === void 0 ? void 0 : payload.method);
                }
                return 'auth/sign-in/service';
            },
        },
        method: HttpMethod.POST,
        headers: {
            'Content-Type': 'application/json',
        },
        // requestBody: ({ email, password }) => JSON.stringify({ email, password }),
        requestBody: {
            byEmail: function (data) { return JSON.stringify(data); },
            byUsername: function (data) { return JSON.stringify(data); },
            byPhone: function (data) { return JSON.stringify(data); },
            byService: function (_a) {
                var method = _a.method, data = __rest(_a, ["method"]);
                return JSON.stringify(data);
            },
        },
        prepareData: function (data, payload) {
            var _a, _b, _c, _d;
            if (!data) {
                return null;
            }
            return {
                remember: !!(payload === null || payload === void 0 ? void 0 : payload.remember),
                user: data.user || null,
                access: {
                    token: ((_a = data.access) === null || _a === void 0 ? void 0 : _a.token) || '',
                    expiresIn: ((_b = data.access) === null || _b === void 0 ? void 0 : _b.expiresIn) || '',
                },
                refresh: {
                    token: ((_c = data.refresh) === null || _c === void 0 ? void 0 : _c.token) || '',
                    expiresIn: ((_d = data.refresh) === null || _d === void 0 ? void 0 : _d.expiresIn) || '',
                },
            };
        },
    },
    signUp: {
        // url: 'auth/sign-up', // email and password
        url: {
            baseUrl: 'auth/sign-up',
            byEmail: function () { return 'auth/sign-up'; },
            byUsername: function () { return 'auth/sign-up/username'; },
            byPhone: function () { return 'auth/sign-up/phone'; },
            byService: function (payload) {
                if (payload === null || payload === void 0 ? void 0 : payload.method) {
                    return "auth/sign-up/".concat(payload === null || payload === void 0 ? void 0 : payload.method);
                }
                return 'auth/sign-up/service';
            },
        },
        method: HttpMethod.POST,
        headers: {
            'Content-Type': 'application/json',
        },
        // requestBody: ({ email, password }) => JSON.stringify({ email, password }),
        requestBody: {
            byEmail: function (data) { return JSON.stringify(data); },
            byUsername: function (data) { return JSON.stringify(data); },
            byPhone: function (data) { return JSON.stringify(data); },
            byService: function (_a) {
                var method = _a.method, data = __rest(_a, ["method"]);
                return JSON.stringify(data);
            },
        },
        prepareData: function (data, payload) {
            if (!data) {
                return null;
            }
            data.remember = (payload === null || payload === void 0 ? void 0 : payload.remember) || false;
            return data;
        },
    },
    signOut: {
        url: 'auth/sign-out',
    },
    userMe: {
        url: 'users/me',
        method: HttpMethod.GET,
        headers: {
            'Content-Type': 'application/json',
        },
        prepareData: function (data) { return data; },
    },
    refreshToken: {
        method: HttpMethod.GET,
        url: 'auth/refresh-token',
        headers: {
            'Content-Type': 'application/json',
        },
        prepareData: function (data) { return data; },
        check401: function (data) { return (Array.isArray(data === null || data === void 0 ? void 0 : data.message) ? data === null || data === void 0 ? void 0 : data.message[0] : data === null || data === void 0 ? void 0 : data.message) === 'Token has expired'; },
    },
};
exports.updateConfig = (function () {
    var update = function (parent, obj) {
        if (obj) {
            Object.keys(obj).forEach(function (key) {
                if (typeof obj[key] !== 'undefined') {
                    if (typeof obj[key] === 'object') {
                        if (Object.keys(obj[key]).length) {
                            update(parent[key], obj[key]);
                        }
                    }
                    else {
                        parent[key] = obj[key];
                    }
                }
            });
        }
    };
    return function (newConfig) {
        update(exports.config, newConfig);
        return exports.config;
    };
})();
function setActions(actions) {
    exports.config.actions = actions;
}
exports.setActions = setActions;
